// src/services/serviceAreaApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { 
  OMNISTACK_BASE_URL, 
  getPrepareHeaders 
} from '@/hooks/common/common-functions'

export const serviceAreaApi = createApi({
  reducerPath: 'serviceAreaApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${OMNISTACK_BASE_URL}business/service-areas`,
    prepareHeaders: (headers) => {
      getPrepareHeaders({
        headers,
        isClientApiKey: true,
      });
      
      const businessApiKey = localStorage.getItem('businessApiKey');
      if (businessApiKey) {
        headers.set('business-x-api-key', businessApiKey);
      }
      
      return headers;
    },
  }),
  tagTypes: ['ServiceAreas', 'CoverageStats'],
  endpoints: (builder) => ({
    // Get service areas
    getServiceAreas: builder.query({
      query: ({ businessId, status, region, priority }) => ({
        url: '',
        params: { businessId, status, region, priority }
      }),
      providesTags: ['ServiceAreas']
    }),

    // Create service area - FIXED: businessId as query param
    createServiceArea: builder.mutation({
      query: ({ businessId, ...areaData }) => ({
        url: '',
        method: 'POST',
        params: { businessId }, // Send businessId as query parameter
        body: areaData // Send other data in the body (excluding businessId)
      }),
      invalidatesTags: ['ServiceAreas', 'CoverageStats']
    }),

    // Update service area
    updateServiceArea: builder.mutation({
      query: ({ areaId, businessId, ...updateData }) => ({
        url: `/${areaId}`,
        method: 'PUT',
        params: { businessId },
        body: updateData
      }),
      invalidatesTags: ['ServiceAreas', 'CoverageStats']
    }),

    // Delete service area
    deleteServiceArea: builder.mutation({
      query: ({ areaId, businessId }) => ({
        url: `/${areaId}`,
        method: 'DELETE',
        params: { businessId }
      }),
      invalidatesTags: ['ServiceAreas', 'CoverageStats']
    }),

    // Analyze coverage
    analyzeCoverage: builder.mutation({
      query: ({ businessId }) => ({
        url: '/analyze',
        method: 'POST',
        params: { businessId }
      }),
      invalidatesTags: ['CoverageStats']
    }),

    // Get coverage statistics
    getCoverageStats: builder.query({
      query: ({ businessId }) => ({
        url: '/stats',
        params: { businessId }
      }),
      providesTags: ['CoverageStats']
    }),

    // Assign team to area
    assignTeamToArea: builder.mutation({
      query: ({ areaId, businessId, teamId }) => ({
        url: `/${areaId}/assign-team`,
        method: 'POST',
        params: { businessId },
        body: { teamId }
      }),
      invalidatesTags: ['ServiceAreas']
    })
  })
});

export const {
  useGetServiceAreasQuery,
  useCreateServiceAreaMutation,
  useUpdateServiceAreaMutation,
  useDeleteServiceAreaMutation,
  useAnalyzeCoverageMutation,
  useGetCoverageStatsQuery,
  useAssignTeamToAreaMutation
} = serviceAreaApi;